export default {
    methods: {
        trackEvent(eventName, props={}){
            const route = window.location.href;
            const page_name = this.$route?.name.replace(/\./g, " ") ?? 'Landing Page';
            const globalProps = {
                                    route,
                                    page_name,
                                    product: 'Seamlesshiring',
                                };
            this.$mixpanel.trackEvent(eventName, {...globalProps, ...props});
        },
        
        reloadPage() {
            const currentRoute = this.$route; // Get the current route
            this.$router.replace({ path: '/temp-route' });
            this.$nextTick(() => {
                this.$router.replace(currentRoute); // Change the route back to the original
            });
        },
        
        reusableObjectDestructure(arrayList, value1, value2, ...otherKeys){
            if (!Array.isArray(arrayList) || !value1) return [];
            
            return arrayList.reduce((acc, item) => {
                if (!item || typeof item !== "object") return acc;
                
                const formattedItem = {
                    label: item[value1] ?? "",
                    value: item[value2] ?? item[value1] ?? "",
                    ...Object.fromEntries(otherKeys.map(key => [key, item[key]]).filter(([_, v]) => v !== undefined))
                };
                
                acc.push(formattedItem);
                return acc;
            }, []);
        }

    }
}
